export default __webpack_public_path__ + "files/media/plane-desktop@2x.ace20c63.webp";